// extracted by mini-css-extract-plugin
export default {"addProductBtnContainer":"All_addProductBtnContainer__CLla2","add-product-btn":"All_add-product-btn__CgMvC","productBtn":"All_productBtn__C-70B"};